export default {
  transactionModuleTasks: [],
  transactionModuleTask: undefined,
};
